module.exports = __webpack_public_path__ + "img/syukyaku-top-ira004.05438ac6.png";